import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce } from 'intact-vue';
import { getRestProps } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    to = _this$get.to,
    children = _this$get.children,
    className = _this$get.className;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-breadcrumb-item"] = true, _classNameObj[className] = className, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), to ? _$ce(2, 'a', children, 0, _$cn(k + "-breadcrumb-link"), {
    'ev-click': this.onClick
  }) : _$ce(2, 'span', children, 0, _$cn(k + "-breadcrumb-link")));
}
;